import { render, staticRenderFns } from "./ReviewDifference.vue?vue&type=template&id=ad94fa94&scoped=true&"
import script from "./ReviewDifference.vue?vue&type=script&lang=js&"
export * from "./ReviewDifference.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDifference.vue?vue&type=style&index=0&id=ad94fa94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad94fa94",
  null
  
)

export default component.exports